import React from "react";
import styled from "styled-components";

const StyledLink = styled.a`
  text-decoration: none;
  color: var(--sinch-comp-color-menu-option-color-default-border-active);
`;

export interface LinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  to: string;
}
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  function LinkWithRef({ onClick, target, to, ...rest }, ref) {
    function handleClick(
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) {
      if (onClick) onClick(event);
      if (!event.defaultPrevented) {
        event.preventDefault();
        history.pushState({}, "", to);
      }
    }

    return (
      <StyledLink {...rest} onClick={handleClick} ref={ref} target={target} />
    );
  }
);
